import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "tab"]
  static values = {
    defaultPath: String
  }

  connect() {
    window.addEventListener("popstate", this.handlePopstate.bind(this))

    const lastVisitedUrl = localStorage.getItem('lastVisitedTab')
    const currentPatientId = this.getCurrentPatientId()

    if (lastVisitedUrl && this.isSamePatient(lastVisitedUrl, currentPatientId) && this.isValidUrlForCurrentContext(lastVisitedUrl)) {
      if (lastVisitedUrl !== this.frameTarget.src) {
        this.loadFrame(lastVisitedUrl)
      }
      this.updateActiveTab(lastVisitedUrl)
    } else {
      localStorage.removeItem('lastVisitedTab')
      this.updateActiveTab(this.defaultPathValue || this.frameTarget.src)
    }
  }

  navigate(event) {
    event.preventDefault()
    const frameUrl = event.currentTarget.href

    localStorage.setItem('lastVisitedTab', frameUrl)
    history.pushState({ frameUrl }, "", window.location.pathname)
    this.loadFrame(frameUrl)
    this.updateActiveTab(frameUrl)
  }

  handlePopstate(event) {
    const state = event.state
    if (state && state.frameUrl) {
      localStorage.setItem('lastVisitedTab', state.frameUrl)
      this.loadFrame(state.frameUrl)
      this.updateActiveTab(state.frameUrl)
    }
  }

  loadFrame(url) {
    this.frameTarget.src = url
  }

  updateActiveTab(currentUrl) {
    const fullUrl = new URL(currentUrl, window.location.origin).href

    this.tabTargets.forEach(tab => {
      const tabUrl = new URL(tab.href, window.location.origin).href
      const isActive = tabUrl === fullUrl
      tab.classList.toggle('tg-primary', isActive)
      tab.classList.toggle('text-white', isActive)
      tab.classList.toggle('bg-white', !isActive)
      tab.classList.toggle('text-gray-600', !isActive)
    })
  }

  disconnect() {
    window.removeEventListener("popstate", this.handlePopstate.bind(this))
    localStorage.removeItem('lastVisitedTab')
  }

  getCurrentPatientId() {
    const patientIdMatch = window.location.pathname.match(/patients\/(\d+)/)
    return patientIdMatch ? patientIdMatch[1] : null
  }

  isSamePatient(url, currentPatientId) {
    if (!currentPatientId) return false
    return url.includes(`/patients/${currentPatientId}/`)
  }

  isValidUrlForCurrentContext(url) {
    const currentContext = this.getCurrentContext()

    if (currentContext) {
      return url.includes(`/${currentContext}/`)
    }

    return false
  }

  getCurrentContext() {
    const pathSegments = window.location.pathname.split('/').filter(segment => segment.length > 0)
    const patientsIndex = pathSegments.indexOf('patients')
    if (patientsIndex > 0) {
      return pathSegments[patientsIndex - 1]
    }

    return null
  }
}
